import { useQuery } from "@tanstack/react-query";
import { useCallback, useState } from "react";
import { getLocationSites } from "../../../../../core/api/services/site.service";
import TableSort from "../../../../../shared/helpers/table-sort";
import capitalizeFirst from "../../../../../shared/helpers/upper-case";
import SiteTableComponent from "./site-table.component";

const SiteComponent = () => {
  const [PageNumber, setPageNum] = useState<number>(1);
  const [siteSearchValue, setSiteSearchValue] = useState("");
  const pageSize = 10;

  const [SortBy, setSortBy] = useState<any>(capitalizeFirst("siteCode"));
  const [SortDirection, setSortDirection] = useState<any>("desc");

  const [columns, setColumns] = useState([
    {
      title: "Site Code",
      label: "siteCode",
      isSorted: true,
      // width: "8rem"
    },
    {
      title: "Site Name",
      label: "name",
      // width: "8rem"
    },
    {
      title: "Town Council",
      label: "towncouncilName",
      // width: "8rem"
    },
    {
      title: "Project Category",
      label: "siteProjectType",
      // width: "8rem"
    },
  ]);

  const {
    data: locationSiteData,
    isLoading: isLoadingLocationSites,
    refetch,
  } = useQuery({
    queryKey: [
      "getLocationSites",
      PageNumber,
      SortBy,
      SortDirection,
      siteSearchValue,
    ],
    queryFn: ({ signal }) =>
      getLocationSites(
        PageNumber,
        pageSize,
        SortBy,
        SortDirection,
        siteSearchValue,
        signal
      ),
  });

  const onRefetchData = () => {
    if (locationSiteData?.numberOfRecords <= pageSize + 1) {
      setPageNum(1);
    }
    refetch();
  };

  const handleChangePage = useCallback((page: number): void => {
    setPageNum(page);
  }, []);

  const handleSearch = useCallback((searchVal: string): void => {
    setPageNum(1);
    setSiteSearchValue(searchVal);
  }, []);

  const handleChangeSort = useCallback(
    async (sortBy: string, sortDirection: any) => {
      if (!sortBy || !sortDirection) return;
      setSortBy(sortBy);
      setSortDirection(sortDirection);

      const copyColumns: any = await TableSort(columns, sortBy);
      setColumns(copyColumns);
    },
    []
  );

  return (
    <div>
      <SiteTableComponent
        columns={columns}
        data={locationSiteData?.data}
        totalNumberOfRecords={locationSiteData?.numberOfRecords}
        pageSize={pageSize}
        current={PageNumber}
        onChangePage={handleChangePage}
        onRefetchData={onRefetchData}
        onChangeSort={handleChangeSort}
        isLoading={isLoadingLocationSites}
        onSearch={handleSearch}
      />
    </div>
  );
};

export default SiteComponent;
